import { ScrollArea } from 'components/elements';
import { styled } from 'styles';

export const TableRowDetailsContent = styled(ScrollArea)`
  background-color: ${({ theme }) => theme.table.details.background};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.shadow.highlight} inset;
`;

export const StyledTableRowDetails = styled.div`
  border-radius: ${({ theme }) => theme.radius.small};
  cursor: default;
  padding: ${({ theme }) => theme.spacing.absolute.tiny} 0;
  user-select: auto;
  width: 100%;
`;

TableRowDetailsContent.displayName = 'TableRowDetailsContent';
StyledTableRowDetails.displayName = 'TableRowDetails.Styled';
